export function directionsSetterComponent() {
    return {
        restrict: 'E',
        scope: {},
        controllerAs: 'vm',
        controller: 'DirectionsSetterCtrl',
        bindToController: {
            searchedPlaceCoordinates: '=',
            clickedMarkerCoordinates: '=',
            directionsService: '=',
            directionsDisplay: '='
        }
    };
}

export class DirectionsSetterCtrl {

    constructor($scope, $q, storeServ) {
        this.$scope = $scope;
        this.$q = $q;

        this.ngOnInit();

        this.$scope.$on('$destroy', this.ngOnDestroy.bind(this));
    }

    ngOnInit() {
        this.getRoute();
        
        this.routePromise.then((route) => {
            this.directionsDisplay.setDirections(route);
        });
    }

    getRoute() {
        this.routeDeferred = this.$q.defer();

        this.directionsService.route({
            origin: {
                lat: this.searchedPlaceCoordinates.location.lat,
                lng: this.searchedPlaceCoordinates.location.lng
            },
            destination: {
                lat: this.clickedMarkerCoordinates.lat,
                lng: this.clickedMarkerCoordinates.lng
            },
            travelMode: google.maps.DirectionsTravelMode.WALKING
        }, (route) => {
            if (route) {
                this.routeDeferred.resolve(route);
            } else {
                this.routeDeferred.reject();
            }
        });

        this.routePromise = this.routeDeferred.promise;
    }

    ngOnDestroy() {
        this.routeDeferred.reject();

        if (this.directionsDisplay.getDirections()) this.directionsDisplay.set('directions', null);
    }
}

DirectionsSetterCtrl.$inject = ['$scope', '$q'];